/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-redux/prefer-separate-component-file */
/* eslint-disable import/no-default-export */
/* eslint-disable react-redux/connect-prefer-named-arguments */
/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { VALIDATORS_CONFIG, MOCK_TEST_DATA, TEST_DATA } from '../../../../../../common/constants'
import {
    setDeviceSerialNumber,
    setTariffs,
    setDeviceActivationKey,
    setLicensePlate,
    setChoosedPropertyType,
    setFetchProcessSuccess,
    setSelectedSubscriptionOption,
    setRmaDevices,
    setSubscriptionSelectedPage,
    setProviderNo,
    setGenerationRequired,
    setIsDakDevice,
    setModels,
    setGenerations,
    setGenerationSelected,
    setGenerationIdSelected,
    setGenerationObject,
    setBrandId,
    setModelId,
    setFuelTypeIndex,
    setFuelTypesGroup
} from '../../../../../../redux/actions'
import {
    verifyDak,
    verifyDevice,
    loadingProcess,
    showUnit,
    rmaDevices,
    getValidator,
    isURLParamExists
} from '../../../common/operations'
import { ActivatedUnitsHistory } from '../../activatedUnitsHistory/activated-units-history'
import { ConfirmField } from './confirm-field'
import { DakField } from './dak-field'
import { SerialNumberField } from './serial-field'

import styles from '../../pages/pages.module.css'

const DevicePage = ({
    activationCode,
    activeStep,
    customerNumber,
    deviceActivationKey,
    deviceSerialNumber,
    fetchProcessSuccess,
    intl,
    isDakDevice,
    setBrandId,
    setChoosedPropertyType,
    setDeviceActivationKey,
    setDeviceSerialNumber,
    setFetchProcessSuccess,
    setFuelTypeIndex,
    setFuelTypesGroup,
    setGenerationObject,
    setGenerationRequired,
    setGenerationSelected,
    setGenerations,
    setIsDakDevice,
    setLicensePlate,
    setModelId,
    setModels,
    setPagerFunctions,
    setProviderNo,
    setRmaDevices,
    setSelectedSubscriptionOption,
    setStep,
    setSubscriptionSelectedPage,
    setTariffs
}) => {
    const conf = VALIDATORS_CONFIG.step2

    const [state, setStateOfProperty] = useState({
        confirm: MOCK_TEST_DATA ? TEST_DATA.step2.deviceSerialNumber : deviceSerialNumber,
        dak: MOCK_TEST_DATA ? TEST_DATA.step2.deviceActivationKey : deviceActivationKey,
        equals: false,
        serial: MOCK_TEST_DATA ? TEST_DATA.step2.deviceSerialNumber : deviceSerialNumber,
        serverErrorMessage: '',
        serverVerified: false
    })

    const { confirm, dak, serial, serverErrorMessage, serverVerified } = state

    const [validatorsState, setStateOfValidatorProperty] = useState({
        confirmCorrectness: getValidator(conf.serialNo.enabled.equality, serial === confirm && serial.length > 10),
        dakCorrectness: getValidator(
            conf.dakFormat.enabled,
            (conf.dakFormat.twelveCharsRegex.test(dak) && dak.replace(/[\s\-]/g, '').length === 12) ||
                (conf.dakFormat.tenCharsRegex.test(dak) && dak.replace(/[\s\-]/g, '').length === 10)
        ),
        serialCorrectness: getValidator(
            conf.serialNo.enabled.correctness,
            conf.serialNo.regex.test(serial) && serial.length <= 12
        )
    })

    const { confirmCorrectness, dakCorrectness, serialCorrectness } = validatorsState

    const setState = statesObj => {
        setStateOfProperty(prevState => ({ ...prevState, ...statesObj }))
    }

    const setValidatorState = statesObj => {
        setStateOfValidatorProperty(prevState => ({ ...prevState, ...statesObj }))
    }

    const setVerificationSuccess = () => {
        setState({ serverErrorMessage: '', serverVerified: true })

        if (MOCK_TEST_DATA) {
            setState({ dak: TEST_DATA.step2.dak })
        }
    }

    const checkErrorMessage = (error, message) => {
        return error?.data?.message?.errorCode.includes(message)
    }

    const fetchRmaDevices = (verifyDeviceResponse, showUnitResponse) => {
        rmaDevices(activationCode, customerNumber, serial)
            .then(rmaDevicesResponse => {
                setFetchProcessSuccess(true)
                setRmaDevices(rmaDevicesResponse.data)

                const isRmaDevicesAvailable = rmaDevicesResponse.data.length > 0
                const isTariffsAvailable = verifyDeviceResponse.data.deviceactivationoptions.length > 0
                const isUnitActivated = showUnitResponse.data.activationState === 'ACTIVATED'
                const isUnitPreactivated = showUnitResponse.data.activationState === 'PRE_ACTIVATED'
                const isContractExpired = showUnitResponse.data.expired

                if (isUnitPreactivated) {
                    setState({ serverErrorMessage: intl.translate('ap_unit_already_preactivated') })
                    return
                }

                if (isTariffsAvailable) {
                    if (isUnitActivated && !isContractExpired) {
                        setState({ serverErrorMessage: intl.translate('ap_device_already_activated') })
                    } else {
                        setTariffs(verifyDeviceResponse.data.deviceactivationoptions)
                        setProviderNo(verifyDeviceResponse.data.providerNo)
                        setVerificationSuccess()
                    }
                } else {
                    if (isRmaDevicesAvailable) {
                        setSelectedSubscriptionOption(true)
                        setProviderNo(verifyDeviceResponse.data.providerNo)
                        setSubscriptionSelectedPage('rma')
                        setVerificationSuccess()
                    } else {
                        setState({ serverErrorMessage: intl.translate('ap_step2_error_tarrifstatus') })
                    }
                }

                if (!isRmaDevicesAvailable) {
                    setSelectedSubscriptionOption(true)
                    setSubscriptionSelectedPage('wfsubscription')
                }
            })
            .catch(() => {
                setFetchProcessSuccess(true)
                setState({ serverErrorMessage: intl.translate('ap_generic_error_text_1') })
            })
    }

    const fetchShowUnit = verifyDeviceResponse => {
        showUnit(activationCode, customerNumber, serial)
            .then(showUnitResponse => {
                fetchRmaDevices(verifyDeviceResponse, showUnitResponse)
                setIsDakDevice(verifyDeviceResponse.data.verifyDak)
            })
            .catch(error => {
                setFetchProcessSuccess(true)
                if (checkErrorMessage(error, 'err_no_data_to_unit')) {
                    setState({ serverErrorMessage: intl.translate('ap_device_not_exist_error') })
                } else {
                    setState({ serverErrorMessage: intl.translate('wf_serialnumber_exists') })
                }
            })
    }

    const verifyDataOnServer = () => {
        setFetchProcessSuccess(false)
        verifyDevice(activationCode, customerNumber, serial)
            .then(verifyDeviceResponse => {
                setModels([])
                setGenerations([])
                setGenerationSelected(0)
                setGenerationIdSelected(0)
                setGenerationObject({
                    brand: '',
                    fuelType: '',
                    isFuelTypeShow: false,
                    model: '',
                    yearFrom: '',
                    yearTo: ''
                })
                setBrandId(0)
                setModelId(0)
                setFuelTypeIndex(-1)
                setFuelTypesGroup({ fuelType: '', groupedGenerations: [] })

                fetchShowUnit(verifyDeviceResponse)
                setGenerationRequired(verifyDeviceResponse.data.generationRequired)
            })
            .catch(error => {
                setFetchProcessSuccess(true)
                if (checkErrorMessage(error, 'err_already_activated')) {
                    setState({ serverErrorMessage: intl.translate('ap_device_already_activated') })
                } else {
                    setState({ serverErrorMessage: intl.translate('ap_device_not_exist_error') })
                }
            })
    }

    useEffect(() => {
        setSelectedSubscriptionOption(false)
        setLicensePlate('')
        setChoosedPropertyType('')
        setRmaDevices([])
        setTariffs([])

        if (serial.length > 0 && isURLParamExists('serial')) {
            verifyDataOnServer()
        }
    }, [])

    const onBack = () => {
        setRmaDevices([])
        setStep(activeStep - 1)

        setDeviceSerialNumber(serial)
    }

    const onNext = () => {
        if (isDakDevice) {
            const dakFormatted = dak.replace(/[\s\-]/g, '')

            const body = {
                deviceActivationKey: dakFormatted,
                deviceSerialNumber: serial
            }
            setFetchProcessSuccess(false)
            verifyDak(activationCode, customerNumber, body)
                .then(() => {
                    setFetchProcessSuccess(true)
                    setStep(activeStep + 1)
                })
                .catch(() => {
                    setFetchProcessSuccess(true)
                    setState({
                        serverErrorMessage:
                            intl.translate('ap_step2_error_dak') +
                            ' ' +
                            intl.translate('ap_generic_customersupport_plain')
                    })
                })
        } else {
            setStep(activeStep + 1)
        }

        setDeviceSerialNumber(serial)
        setDeviceActivationKey(isDakDevice ? dak : '')
    }

    useEffect(() => {
        setPagerFunctions({
            onBack,
            onNext,
            validator:
                ((!isDakDevice && confirmCorrectness && serialCorrectness) ||
                    (isDakDevice && serialCorrectness && dakCorrectness)) &&
                serverVerified
        })

        setValidatorState({
            confirmCorrectness: getValidator(conf.serialNo.enabled.equality, serial === confirm && serial.length > 10),
            dakCorrectness: getValidator(
                conf.dakFormat.enabled,
                (conf.dakFormat.twelveCharsRegex.test(dak) && dak.replace(/[\s\-]/g, '').length === 12) ||
                    (conf.dakFormat.tenCharsRegex.test(dak) && dak.replace(/[\s\-]/g, '').length === 10)
            ),
            serialCorrectness: getValidator(
                conf.serialNo.enabled.correctness,
                conf.serialNo.regex.test(serial) && serial.length <= 12
            )
        })
    }, [serial, confirm, dak, serverVerified, serialCorrectness, confirmCorrectness, dakCorrectness])

    const onSerialChange = e => {
        setState({ confirm: '', serial: e.target.value.toUpperCase() })
    }

    return (
        <div>
            <div className={styles['content-wrapper']}>
                {loadingProcess(fetchProcessSuccess)}
                <div>
                    <div className={styles['page-description']}>
                        <p>{intl.translate('ap_step2_description')}</p>
                    </div>
                    <SerialNumberField
                        {...{
                            intl,
                            isDakDevice,
                            onSerialChange,
                            serial,
                            serialCorrectness,
                            serverVerified,
                            verifyDataOnServer
                        }}
                    />
                    {isDakDevice ? (
                        <DakField
                            {...{
                                dak,
                                dakCorrectness,
                                intl,
                                onDakChange: e => setState({ dak: e.target.value.toUpperCase() }),
                                serverVerified
                            }}
                        />
                    ) : (
                        <ConfirmField
                            {...{
                                confirm,
                                confirmCorrectness,
                                intl,
                                onConfirmChange: e => setState({ confirm: e.target.value.toUpperCase() }),
                                serverVerified
                            }}
                        />
                    )}
                    <div className={styles['error-message']}>{serverErrorMessage}</div>
                    <ActivatedUnitsHistory {...{ activationCode, customerNumber, intl }} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    const { activationCode } = state.activationCode || ''
    const { customerNumber } = state.customerNumber || ''
    const { deviceSerialNumber } = state.deviceSerialNumber || ''
    const { deviceActivationKey } = state.deviceActivationKey || ''
    const { isDakDevice } = state.isDakDevice || false
    const { rmaDevices } = state.rmaDevices || []
    const { fetchProcessSuccess } = state.fetchProcessSuccess || true
    return {
        activationCode,
        customerNumber,
        deviceActivationKey,
        deviceSerialNumber,
        fetchProcessSuccess,
        isDakDevice,
        rmaDevices
    }
}

DevicePage.propTypes = {
    activationCode: PropTypes.string,
    activeStep: PropTypes.number,
    customerNumber: PropTypes.string,
    deviceActivationKey: PropTypes.string,
    deviceSerialNumber: PropTypes.string,
    fetchProcessSuccess: PropTypes.boolean,
    fetchTranslateSuccess: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func),
    isDakDevice: PropTypes.boolean,
    setBrandId: PropTypes.func,
    setChoosedPropertyType: PropTypes.func,
    setDeviceActivationKey: PropTypes.func,
    setDeviceSerialNumber: PropTypes.func,
    setFetchProcessSuccess: PropTypes.func,
    setFuelTypeIndex: PropTypes.func,
    setFuelTypesGroup: PropTypes.func,
    setGenerationObject: PropTypes.func,
    setGenerationRequired: PropTypes.func,
    setGenerationSelected: PropTypes.func,
    setGenerations: PropTypes.func,
    setIsDakDevice: PropTypes.func,
    setLicensePlate: PropTypes.func,
    setModelId: PropTypes.func,
    setModels: PropTypes.func,
    setPagerFunctions: PropTypes.func,
    setProviderNo: PropTypes.func,
    setRmaDevices: PropTypes.func,
    setSelectedSubscriptionOption: PropTypes.func,
    setStep: PropTypes.func,
    setSubscriptionSelectedPage: PropTypes.func,
    setTariffs: PropTypes.func
}

export default connect(mapStateToProps, {
    setBrandId,
    setChoosedPropertyType,
    setDeviceActivationKey,
    setDeviceSerialNumber,
    setFetchProcessSuccess,
    setFuelTypeIndex,
    setFuelTypesGroup,
    setGenerationIdSelected,
    setGenerationObject,
    setGenerationRequired,
    setGenerationSelected,
    setGenerations,

    setIsDakDevice,
    setLicensePlate,
    setModelId,
    setModels,
    setProviderNo,
    setRmaDevices,
    setSelectedSubscriptionOption,
    setSubscriptionSelectedPage,
    setTariffs
})(DevicePage)
